export default "__VITE_ASSET__BD5jiMfe__"